import { render, staticRenderFns } from "./Section-06.vue?vue&type=template&id=6b377b4e&scoped=true&"
import script from "./Section-06.vue?vue&type=script&lang=js&"
export * from "./Section-06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b377b4e",
  null
  
)

export default component.exports